import styled, { css } from 'styled-components';

interface ScCurrenciesItemProps {
  active?: boolean;
}

export const ScCurrenciesItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ScCurrenciesItem = styled.div<ScCurrenciesItemProps>`
  display: grid;
  grid-template-columns: 1fr auto;
  border-radius: 8px;
  padding: 8px;
  gap: 12px;

  & > .content {
    display: flex;
    column-gap: 12px;
    align-items: center;
    overflow: hidden;
    & > div {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 16px;
      line-height: 1.75;
      color: ${({ theme }) => theme.grayColor1};
      transition: 0.3s;
    }

    & > img {
      width: 24px;
      height: 24px;
    }
  }

  & > button {
    margin: auto 0;
  }

  ${({ active }) =>
    active &&
    css`
      background-color: ${({ theme }) => theme.grayColor6};

      & > .content {
        div {
          font-weight: 700;
          letter-spacing: 0.01em;
          color: ${({ theme }) => theme.whiteColor};
        }
      }
    `}
`;
